import http from "../../http-common";
/* eslint-disable */
class PengurusKatiService {
  pengurusList(page, itemPerPage, keyword) {
    return http.get(
      "/pengurus-kati/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    // bodyFormData.append("nama", data.nama);
    bodyFormData.append("user_id", data.user_id);
    bodyFormData.append("urutan", data.urutan);

    if (data.selectedDivisi && data.selectedDivisi != undefined) {
      bodyFormData.append("organisasi_divisi_id", data.selectedDivisi.code);
    }

    if (data.selectedJabatan && data.selectedJabatan != undefined) {
      bodyFormData.append("organisasi_jabatan_id", data.selectedJabatan.code);
    }

    if (data.selectedSubJabatan && data.selectedSubJabatan != undefined) {
      bodyFormData.append(
        "organisasi_sub_jabatan_id",
        data.selectedSubJabatan.code
      );
    }

    return http.post("/pengurus-kati", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    // bodyFormData.append("nama", data.nama);
    bodyFormData.append("user_id", data.user_id);
    bodyFormData.append("urutan", data.urutan);

    if (data.selectedDivisi && data.selectedDivisi != undefined) {
      bodyFormData.append("organisasi_divisi_id", data.selectedDivisi.code);
    }

    if (data.selectedJabatan && data.selectedJabatan != undefined) {
      bodyFormData.append("organisasi_jabatan_id", data.selectedJabatan.code);
    }

    if (data.selectedSubJabatan && data.selectedSubJabatan != undefined) {
      bodyFormData.append(
        "organisasi_sub_jabatan_id",
        data.selectedSubJabatan.code
      );
    }

    return http.put(`/pengurus/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/pengurus/kati/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new PengurusKatiService();
